import styled from "styled-components";
//import px2vw from "utils/px2vw";


export const Area = styled.div.attrs(props => ({

    backgroundColor:    props.backgroundColor || "transparent", //"#191e28", //"#EDEEF1",

    width:              props.width || "98%",
    height:             props.height || "auto",
    margin:             props.margin || "0 0 0 0",

    zIndex:             props.zIndex || "3", 
    top:                props.top || "0", 
    //left:               props.left || "calc(50% - 45%)",
    left:               props.left || "1%",

    titleFontFamily:         props.titleFontFamily || 'Arial, Helvetica, sans-serif',
    titleFontSize:           props.titleFontSize || "24px",
    titleFontWeight:         props.titleFontWeight  || "500",
    titleTextAlign:          props.titleTextAlign || "left",
    titleTextDecoration:     props.titleTextDecoration  || "none",
    titleTextColor:          props.titleTextColor || "#000",


    xButtonFontFamily:         props.xButtonFontFamily || 'Arial, Helvetica, sans-serif',
    xButtonFontSize:           props.xButtonFontSize || "24px",
    xButtonFontWeight:         props.xButtonFontWeight  || "500",
    xButtonTextAlign:          props.xButtonTextAlign || "center",
    xButtonTextDecoration:     props.xButtonTextDecoration  || "none",
    xButtonTextColor:          props.xButtonTextColor || "white",


    labelFontFamily:         props.labelFontFamily || 'Arial, Helvetica, sans-serif',
    labelFontSize:           props.labelFontSize || "18px",
    labelFontWeight:         props.labelFontWeight  || "500",
    labelTextAlign:          props.labelTextAlign || "left",
    labelTextDecoration:     props.labelTextDecoration  || "none",
    labelTextColor:          props.labelTextColor || "#000",

    cellFontFamily:         props.cellFontFamily || 'Arial, Helvetica, sans-serif',
    cellFontSize:           props.cellFontSize || "16px",
    cellFontWeight:         props.cellFontWeight  || "500",
    cellTextAlign:          props.cellTextAlign || "left",
    cellTextDecoration:     props.cellTextDecoration  || "none",
    cellTextColor:          props.cellTextColor || "black",
    





    headingFontFamily:         props.headingFontFamily || 'Arial, Helvetica, sans-serif',
    headingFontSize:           props.headingFontSize || "24px",
    headingFontWeight:         props.headingFontWeight  || "550",
    headingTextAlign:          props.headingTextAlign || "left",
    headingTextDecoration:     props.headingTextDecoration  || "none",
    headingTextColor:          props.headingTextColor || "lightgray",

    pgraphFontFamily:         props.pgraphFontFamily || 'Arial, Helvetica, sans-serif',
    pgraphFontSize:           props.pgraphFontSize || "18px",
    pgraphFontWeight:         props.pgraphFontWeight  || "500",
    pgraphTextAlign:          props.pgraphTextAlign || "left",
    pgraphTextDecoration:     props.pgraphTextDecoration  || "none",
    pgraphTextColor:          props.pgraphTextColor || "lightgray",


    listFontFamily:         props.listFontFamily || 'Arial, Helvetica, sans-serif',
    listFontSize:           props.listFontSize || "18px",
    listFontWeight:         props.listFontWeight  || "500",
    listTextAlign:          props.listTextAlign || "left",
    listTextDecoration:     props.listTextDecoration  || "none",
    listTextColor:          props.listTextColor || "lightgray",



    navFontFamily:         props.navFontFamily || 'Arial, Helvetica, sans-serif',
    navFontSize:           props.navFontSize || "18px",
    navFontWeight:         props.navFontWeight  || "550",
    navTextAlign:          props.navTextAlign || "center",
    navTextDecoration:     props.navTextDecoration  || "none",
    navTextColor:          props.navTextColor || "lightgray",


    buttonFontFamily:         props.buttonFontFamily || 'Arial, Helvetica, sans-serif',
    buttonFontSize:           props.buttonFontSize || "16px",
    buttonFontWeight:         props.buttonFontWeight  || "500",
    buttonTextAlign:          props.buttonTextAlign || "center",
    buttonTextDecoration:     props.buttonTextDecoration  || "none",
    buttonTextColor:          props.buttonTextColor || "white",



    barButtonFontFamily:         props.barButtonFontFamily || 'Arial, Helvetica, sans-serif',
    barButtonFontSize:           props.barButtonFontSize || "20px",
    barButtonFontWeight:         props.barButtonFontWeight  || "500",
    barButtonTextAlign:          props.barButtonTextAlign || "center",
    barButtonTextDecoration:     props.barButtonTextDecoration  || "none",
    barButtonTextColor:          props.barButtonTextColor || "white"



    // border-top:1px solid lightgray;
    // border-bottom:1px solid lightgray; 

    // #90ee90 #caffca



    // position:absolute;
    // z-index:${props => props.zIndex};
    // top:${props => props.top};
    // left:${props => props.left};



}))`

    background-color:${props => props.backgroundColor};

    min-height:150px;
    width:${props => props.width};
    height:${props => props.height};

    padding:0 0 0 0;
    margin:${props => props.margin};



    position:relative;
    float:right;


    display: flex;
    flex-direction: column;
    min-height: 100vh;


    @media (max-width: 100000px) {

        width:100%;
        left:0px;
    }


    @media (max-width: 1000px) {

        width:100%;
        left:0px;
    }



    @media (max-width: 1024px) {

        border:0;
        border-radius:0;

        width:${props => props.width};
        left:${props => props.left};


    }


    .Bar {

        background-color:transparent;
        border-bottom:1px solid #454d5f;

        width:94%;
        height:90px;
        padding:0 0 0 0;
        margin:0 0 0 3%;
        position:relative;
        float:left;

        cursor:default;

    }


        .Bar .Title {

            background-color:transparent;

            width:auto;
            height:auto;
            padding:0 0 0 0;
            margin:10px 0 0 17px;
            position:relative;
            float:left;

            cursor:default;

            font-family:${props => props.titleFontFamily};
            font-size:${props => props.titleFontSize};
            font-weight:${props => props.titleFontWeight};
            text-align:${props => props.titleTextAlign};
            text-decoration:${props => props.titleTextDecoration};
            color:${props => props.titleTextColor};

        }





        .Bar .Button {

            background-color:transparent;

            width:auto;
            height:auto;
            padding:8px 0 4px 0;
            margin:30px 10px 0 10px;
            position:relative;
            float:right;

            cursor:pointer;

            font-family:${props => props.barButtonFontFamily};
            font-size:${props => props.barButtonFontSize};
            font-weight:${props => props.barButtonFontWeight};
            text-align:${props => props.barButtonTextAlign};
            text-decoration:${props => props.barButtonTextDecoration};
            color:${props => props.barButtonTextColor};

            &:hover{

                color:#07a2e3;

            }


        }

        .Bar .ButtonHighlight {

            background-color:transparent;
            width:auto;
            height:auto;
            padding:0 0 0 0;
            margin:30px 10px 0 10px;
            position:relative;
            float:right;
        
        }



            .Bar .ButtonHighlight .Name {

                background-color:transparent;
                width:auto;
                height:auto;
                padding:8px 0 4px 0;
                margin:0 0 0 0;
                position:relative;
                float:left;

                cursor:default;

                font-family:${props => props.barButtonFontFamily};
                font-size:${props => props.barButtonFontSize};
                font-weight:${props => props.barButtonFontWeight};
                text-align:${props => props.barButtonTextAlign};
                text-decoration:${props => props.barButtonTextDecoration};
                color:${props => props.barButtonTextColor};

            }


            .Bar .ButtonHighlight .Underline {

                background-color:#07a2e3;
                width:100%;
                height:4px;
                padding:0 0 0 0;
                margin:0 0 0 0;
                position:relative;
                float:left;

            }




        .Bar .XButton {

            background-color:transparent;

            width:auto;
            height:auto;
            padding:8px 0 4px 0;
            margin:28px 10px 0 20px;
            position:relative;
            float:right;

            cursor:pointer;

            font-family:${props => props.barButtonFontFamily};
            font-size:24px;
            font-weight:${props => props.barButtonFontWeight};
            text-align:${props => props.barButtonTextAlign};
            text-decoration:${props => props.barButtonTextDecoration};
            color:${props => props.barButtonTextColor};

            &:hover{

                color:#07a2e3;

            }


        }






    .Ctrls {

        background-color:transparent;
    
        width:100%;
        height:auto;
        min-height:50px;
    
        padding:0 0 0 0;
        margin:0 0 0 0;
        position:relative;
        float:left;

        cursor:default;

        
    }


        .Ctrls .Button {

            background-color:#0291cd;
            border-radius:7px;

            width:200px;
            height:auto;
            padding:0 0 0 0;
            margin:5px 0 5px calc(50% - 100px);
            position:relative;
            float:left;

            cursor:pointer;

            &:hover{

                background-color: #07a2e3;

            }
        }



        .Ctrls .Button .Name {

            background-color:transparent;

            width:100%;
            height:auto;
            padding:14px 0 9px 0;
            margin:0 0 0 0;
            position:relative;
            float:left;

            cursor:pointer;

            font-family:${props => props.buttonFontFamily};
            font-size:${props => props.buttonFontSize};
            font-weight:${props => props.buttonFontWeight};
            text-align:${props => props.buttonTextAlign};
            text-decoration:${props => props.buttonTextDecoration};
            color:${props => props.buttonTextColor};


        }







    .Bod {

        background-color:transparent;
   
        width:100%;
        height:auto;
        min-height:450px;
    
        padding:0 0 0 0;
        margin:0 0 0 0;
        position:relative;
        float:left;

        cursor:default;
      
    }

    @media (max-width: 1000px) {

        .Bod {

            width:100%;
            margin-left:0px;
 
        }

    }



        .Bod .AdRow {

            background-color:transparent;
            border-bottom:1px solid #454d5f;

            max-width:700px;            
            width:92%;
            height:auto;

            padding:0 0 40px 0;
            margin:7px 0 5px 20px;
            position:relative;
            float:left;

        }


        .Bod .Row {

            background-color:transparent;

            max-width:700px;            
            width:92%;
            height:auto;

            padding:0 0 0 0;
            margin:7px 0 5px 20px;
            position:relative;
            float:left;

        }

    
        .Bod .Box {

            background-color:transparent;
            width:92%;
            height:auto;
            padding:0 0 0 0;
            margin:7px 0 5px 20px;
            position:relative;
            float:left;

        }

        .Bod .Colorline {

            background-color:#07a2e3;
            width:4px;
            height:30px;
            padding:0 0 0 0;
            margin:19px 0 0 10px;
            position:relative;
            float:left;
        }

        .Bod .Graphic {

            background-color:#191e28;

            width:calc(100% - 40px);
            height:100px;
            padding:0 0 0 0;
            margin:20px 0 0 20px;
            position:relative;
            float:left;
        }


        .Bod .Image {

            background-color:#191e28;

            width:calc(100% - 40px);
            height:200px
            padding:0 0 0 0;
            margin:20px 0 0 10px;
            position:relative;
            float:left;
        }



        .Bod .Heading {

            background-color:transparent;

            width:calc(100% - 40px);
            height:auto;
            padding:0 0 3px 0;
            margin:20px 0 0 12px;
            position:relative;
            float:left;

            cursor:default;

            font-family:${props => props.headingFontFamily};
            font-size:${props => props.headingFontSize};
            font-weight:${props => props.headingFontWeight};
            text-align:${props => props.headingTextAlign};
            text-decoration:${props => props.headingTextDecoration};
            color:${props => props.headingTextColor};

        }



        .Bod .Pgraph {

            background-color:transparent;

            width:calc(100% - 60px);
            height:auto;
            padding:0 0 3px 30px;
            margin:7px 0 0 0;
            position:relative;
            float:left;

            cursor:default;

            font-family:${props => props.pgraphFontFamily};
            font-size:${props => props.pgraphFontSize};
            font-weight:${props => props.pgraphFontWeight};
            text-align:${props => props.pgraphTextAlign};
            text-decoration:${props => props.pgraphTextDecoration};
            color:${props => props.pgraphTextColor};


            line-height:1.5;

        }



        .Bod .List {

            background-color:transparent;

            width:calc(100% - 100px);
            height:auto;
            padding:0 0 3px 50px;
            margin:7px 0 0 0;
            position:relative;
            float:left;

            cursor:default;
            line-height:1.5;

        }



            .Bod .List .ListItem {

                background-color:transparent;

                width:100%;
                height:auto;
                padding:0 0 0 0;
                margin:7px 0 0 0;
                position:relative;
                float:left;
                cursor:default;
            }


                .Bod .List .ListItem .Bullet {

                    background-color:#edeef1;
                    border-radius:20px;

                    width:10px;
                    height:10px;

                    padding:0 0 0 0;
                    margin:7.5px 12px 0 0;
                    position:relative;
                    float:left;
                    cursor:default;

                }


                .Bod .List .ListItem .Number {

                    background-color:transparent;

                    width:auto;
                    height:auto;
                    padding:0 0 0 0;
                    margin:0 12px 0 0;
                    position:relative;
                    float:left;

                    cursor:default;

                    font-family:${props => props.listFontFamily};
                    font-size:${props => props.listFontSize};
                    font-weight:600;
                    text-align:${props => props.listTextAlign};
                    text-decoration:${props => props.listTextDecoration};
                    color:#edeef1;


                    line-height:1.5;

                }


                .Bod .List .ListItem .Text {

                    background-color:transparent;

                    width:calc(100% - 30px);
                    height:auto;
                    padding:0 0 3px 0;
                    margin:0 0 0 0;
                    position:relative;
                    float:left;

                    cursor:default;

                    font-family:${props => props.listFontFamily};
                    font-size:${props => props.listFontSize};
                    font-weight:${props => props.listFontWeight};
                    text-align:${props => props.listTextAlign};
                    text-decoration:${props => props.listTextDecoration};
                    color:${props => props.listTextColor};

                    line-height:1.5;

                }






        .Bod .Nav {

            background-color:transparent;

            width:calc(100% - 60px);
            height:auto;
            padding:0 0 3px 30px;
            margin:40px 0 0 0;
            position:relative;
            float:left;

            cursor:default;
            line-height:1.5;

        }


            .Bod .Nav .NavLink {

                background-color:transparent;

                width:100%;
                height:auto;
                padding:0 0 3px 0;
                margin:0 0 0 0;
                position:relative;
                float:left;

                cursor:pointer;

                font-family:${props => props.navFontFamily};
                font-size:${props => props.navFontSize};
                font-weight:${props => props.navFontWeight};
                text-align:${props => props.navTextAlign};
                text-decoration:none;
                color:#07a2e3;

                line-height:1.5;


                &:hover{

                    text-decoration:underline;           
                    color:#fc0;
    

                }


            }





            .Bod .Nav .NavButton {

                background-color:white;
                border-radius:15px;

                width:200px;
                height:auto;
                padding:7px 0 5px 0;
                margin:0 0 0 calc(50% - 100px);
                position:relative;
                float:left;

                cursor:pointer;

                font-family:${props => props.navFontFamily};
                font-size:${props => props.navFontSize};
                font-weight:${props => props.navFontWeight};
                text-align:${props => props.navTextAlign};
                text-decoration:${props => props.navTextDecoration};
                color:#454d5f;

   
                &:hover{

                    background-color:#07a2e3;           
                    color:#fff;
    

                }


            }



            







        .Bod .Label {

            background-color:#edeef1;
            border:1px solid lightgray;
            border-radius:0px;

            width:calc(100% - 10px);
            height:auto;
            padding:10px 0 8px 10px;
            margin:0 0 0 0;
            position:relative;
            float:left;

            cursor:default;

            font-family:${props => props.labelFontFamily};
            font-size:${props => props.labelFontSize};
            font-weight:${props => props.labelFontWeight};
            text-align:${props => props.labelTextAlign};
            text-decoration:${props => props.labelTextDecoration};
            color:${props => props.labelTextColor};

        }



        .Bod .Grid {

            background-color:transparent;
            width:calc(100% - 10px);
            height:auto;
            padding:0 0 0 0;
            margin:5px 0 30px 5px;
            position:relative;
            float:left;
   
        }

        .Bod .Grid .Cell {

            background-color:transparent;
            border-bottom:1px solid lightgray;

            width:100%;
            height:auto;
            padding:0 0 0 0;
            margin:0 0 0 0;
            position:relative;
            float:left;

            cursor:pointer;

            &:hover{

                background-color: #caffca;

            }


        }


            .Bod .Grid .Cell .Name {

                background-color:transparent;

                width:auto;
                height:auto;
                padding:11px 0 7px 10px;
                margin:0 0 0 0;
                position:relative;
                float:left;

                cursor:pointer;

                font-family:${props => props.cellFontFamily};
                font-size:${props => props.cellFontSize};
                font-weight:${props => props.cellFontWeight};
                text-align:${props => props.cellTextAlign};
                text-decoration:${props => props.cellTextDecoration};
                color:${props => props.cellTextColor};


            }


            .Bod .Grid .Cell .Value {

                background-color:transparent;

                width:130px;
                height:auto;
                padding:11px 10px 7px 0;
                margin:0 0 0 0;
                position:relative;
                float:right;

                cursor:pointer;

                font-family:${props => props.cellFontFamily};
                font-size:${props => props.cellFontSize};
                font-weight:${props => props.cellFontWeight};
                text-align:right;
                text-decoration:${props => props.cellTextDecoration};
                color:${props => props.cellTextColor};


            }




`;




